import React from "react";

const LinkedinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      fill="#0A66C2"
      d="M0 1.433C0 .642.658 0 1.469 0H18.53C19.343 0 20 .642 20 1.433v17.134C20 19.36 19.343 20 18.531 20H1.47C.658 20 0 19.359 0 18.567V1.433Zm6.18 15.31V7.71H3.176v9.031H6.18ZM4.677 6.477c1.047 0 1.699-.694 1.699-1.56-.02-.886-.652-1.56-1.679-1.56C3.671 3.357 3 4.031 3 4.917c0 .866.651 1.56 1.659 1.56h.02Zm6.136 10.264V11.7c0-.27.02-.54.099-.733.217-.54.71-1.098 1.54-1.098 1.086 0 1.52.829 1.52 2.043v4.831h3.002v-5.178c0-2.774-1.48-4.065-3.455-4.065-1.593 0-2.307.875-2.706 1.49v.032h-.02l.02-.031V7.71H7.813c.039.847 0 9.031 0 9.031h3.001Z"
    />
  </svg>
);
export default LinkedinIcon;
